const home = require("./home").messages;
const transcript = require("./transcript").messages;

module.exports = {
    messages: {
        de: {
            watchlist: {
                addCurrentPage: "Aktuelle Seite zur Merkliste hinzufügen",
                clearList: "Merkiste leeren",
                confirmDeletion: "Wollen Sie die Merkliste wirklich löschen?",
                currentlist: "Seite(n) auf der " + transcript.de.transcript.watchlist,
                empty: "Die Merkliste ist leer. Sie können die aktuelle Seite durch Klick auf <i class=\"fa fa-plus-square-o\"></i> hinzufügen.",
                filename: "Merkliste_{timestamp}.txt",
                loadList: "Merkliste laden",
                moveDown: "Nach unten",
                moveUp: "Nach oben",
                removePage: "Seite von Merkliste entfernen",
                saveList: "Merkliste speichern",
                title: home.de.home.title,
                uploadFailed: "Hochladen der Merkliste fehlgeschlagen. Bitte prüfen Sie den Inhalt Ihrer Merklistendatei.",
                watchlist: transcript.de.transcript.watchlist
            }
        },
        en: {
            watchlist: {
                addCurrentPage: "Add current page to watchlist",
                clearList: "Delete watchlist",
                confirmDeletion: "Are you sure you want to delete the watchlist?",
                currentlist: "Page(s) on the watchlist",
                empty: "The watchlist is emtpy. You can add the current page by clicking the <i class=\"fa fa-plus-square-o\"></i> symbol.",
                filename: "Watchlist_{timestamp}.txt",
                loadList: "Load watchlist from disk",
                moveDown: "Down",
                moveUp: "Up",
                removePage: "Remove page from watchlist",
                saveList: "Save watchlist",
                title: home.en.home.title,
                uploadFailed: "Loading of watchlist from disk failed. Please check the contents of your watchlist file.",
                watchlist: transcript.en.transcript.watchlist
            }
        },
        fr: {
            watchlist: {
                addCurrentPage: "Ajouter la page affichée à la liste des manuscrits à retenir",
                clearList: "Supprimer la liste",
                confirmDeletion: "Êtes-vous sûr de vouloir supprimer la liste entière?",
                currentlist: "Page(s) sur la liste des manuscrits à retenir",
                empty: "La liste des manuscrits à retenir est vide. Vous pouvez ajouter la page affichée par cliquer sur le symbole <i class=\"fa fa-plus-square-o\"></i>.",
                filename: "Liste_manuscrits_{timestamp}.txt",
                loadList: "Charger une liste",
                moveDown: "Vers le bas",
                moveUp: "Vers le haut",
                removePage: "Retrancher la page",
                saveList: "Sauvegarder la liste",
                title: home.fr.home.title,
                uploadFailed: "Charger de la liste à retenir a échoué. Contrôlez le contenu de votre fichier, s'il vous plaît",
                watchlist: transcript.fr.transcript.watchlist
            }
        }
    }
}
